import { render, staticRenderFns } from "./TiptapInlineEditor.vue?vue&type=template&id=58552cc2"
import script from "./TiptapInlineEditor.vue?vue&type=script&lang=ts"
export * from "./TiptapInlineEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports